import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useClipboard } from '../../hooks';

function CopyClipboard({ target }) {
    const { copy } = useClipboard();
    return (
        <Tooltip disableInteractive title="Copy to the clipboard">
            <ContentCopyIcon
                sx={{
                    marginLeft: '1rem',
                    cursor: 'copy',
                }}
                onClick={() => copy(target)}
            />
        </Tooltip>
    );
}

export default CopyClipboard;
